import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppLoadService, IAccount, ILogin } from '@ebb-v2/ebb-integration';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, take, publishLast, refCount } from 'rxjs/operators';
import { LocationStrategy } from '@angular/common';
import { environment } from './../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {
  private baseUrl: string;
  private siteUrl: string;
  private redirectEnpoint: string;
  public programTypeCodeOptionSet: string;
  public isProgramCeaBb: boolean;

  constructor(
    private http: HttpClient,
    public readonly appLoadService: AppLoadService,
    private locationStrategy: LocationStrategy) {
      
    const env = appLoadService.readEnvironSettings();
    this.baseUrl = env.uriApi;
    this.siteUrl = env.uriSiteRoot;
    this.redirectEnpoint = `redirectEndpoint=${encodeURIComponent(this.siteUrl+'/register/login')}`

    //program used for B2C policy selection
    this.programTypeCodeOptionSet = env.programTypeCodeOptionSet;
    this.isProgramCeaBb = env.ProgramIsCeaBb;
  }

  public loginGuest(guestInfo: ILogin, redirectEndpoint:string): Observable<any> {

    let url = `${this.baseUrl}/Authenticate/loginGuest?email=${encodeURIComponent(guestInfo.email)}`+
        `&firstName=${encodeURIComponent(guestInfo.firstName)}&lastName=${encodeURIComponent(guestInfo.lastName)}&nonce=${encodeURIComponent(guestInfo.nonce)}`;
    if(redirectEndpoint){
      url += `&redirectEndpoint=${encodeURIComponent(this.siteUrl + redirectEndpoint)}&=useCeaPolicy=${this.isProgramCeaBb}`+
                `&b2cRedirectEndpoint=${encodeURIComponent(this.siteUrl + redirectEndpoint)}`;
      window.location.href = url;
      return of(false);
    }

    return this.http.get(url, { withCredentials: true })
      .pipe(
        map(data => data as ILogin),
        catchError(err => throwError(err)),
        publishLast(),
        refCount()
      );
  }

  public createAccount(acctInfo: IAccount): Observable<any> {
    return this.http.post(`${this.baseUrl}/Authenticate/createAccountFromGuest`, acctInfo)
      .pipe(
        map(data => data as JSON),
        catchError(err => throwError(err))
      );
  }

  public sendToB2c(loginHint:string): string {
    const nonce: string = Math.random().toString(36).substring(2, 4) + Math.random().toString(36).substring(2, 4);
    return `${this.baseUrl}/Authenticate/login?nonce=${nonce}&redirect=true&redirectEndpoint=${encodeURIComponent(this.siteUrl + '/register/questionnaire')}&useCeaPolicy=${this.isProgramCeaBb}&loginHint=${encodeURIComponent(loginHint)}`;
  }

  public getB2cToken(): string {
    const nonce: string = Math.random().toString(36).substring(2, 4) + Math.random().toString(36).substring(2, 4);
    let redirect: string;
    redirect = `${this.baseUrl}/Authenticate/loginGuest?nonce=$`
    return redirect;
  }

  public logout(): string {
    return `${this.baseUrl}/Authenticate/logout?${this.redirectEnpoint}`;
  }

  public sendEmail(contactId: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/Authenticate/setVerifyEmailForGuest`, { contactId })
      .pipe(
        map(data => data as JSON),
        catchError(err => throwError(err))
      );
  }
}
